<template>
  <div class="cadastro-usuario">
    <v-container fluid>
      <h1 class="titulo">{{ $t('jogadores.title') }}</h1>
      <div class="box-table">

        <expansionPanelDefault :handleClick="montarLabelFiltro">
          <v-row class="justify-end">
            <v-col cols="12" md="2">
              <v-select
                v-model="typeFilter"
                :items="typeFilters"
                label="Tipo de busca"
                dense
                hide-details
                solo
                class="select-status"
              >
              </v-select>
            </v-col>

            <v-col cols="12" md="2">
              <v-text-field
                append-icon="search"
                :label="labelBuscar"
                single-line
                hide-details
                v-on:keyup.enter="buscarPorEntidade"
                v-model="textSearch"
                color="primary"
                solo
                dense
              />
            </v-col>

            <v-col cols="12" md="2" class="d-flex align-top justify-end">
              <span class="mr-1 label-data">Data Cadastro: </span>
              <FiltroRangeDate
                class="range-date"
                @input="filtrarCreated"
                :value="rangeDateCreated"
                :labelBtn="'Data Cadastro'"
                :actionLabels="{ apply: 'OK' }"
                style="width: 100%;"
              />
            </v-col>

            <v-col cols="12" md="2" class="d-flex align-top justify-end">
              <span class="mr-1 label-data">Data Ultimo Depósito: </span>
              <FiltroRangeDate
                class="range-date"
                @input="filtrarDeposito"
                :value="rangeDateDeposito"
                :labelBtn="'Data Ultimo Depósito'"
                :actionLabels="{ apply: 'OK' }"
                style="width: 100%;"
              />
            </v-col>

            <v-col cols="12" md="1" class="d-flex align-top justify-end">
              <span class="mr-1 label-data">Saldo Positivo: </span>
              <v-switch
                v-model="positiveBalance"
                dense
                hide-details
                class="mt-0"
              ></v-switch>
            </v-col>

            <v-col cols="12" md="1">
              <v-btn
                type="submit"
                dark
                x-large
                style="height: 38px !important;"
                :color="variables.colorSuccess"
                @click.prevent="buscar"
                :loading="loadingPag"> Filtrar </v-btn>
            </v-col>

            <v-col cols="12" md="1">
              <generatePDF
                :params="{
                    vm: this,
                    action: 'getItens',
                    obj: paramsRel,
                    headers: relHeaders,
                    fileName: `Usuários web`,
                    title: `Relatório Usuários web`,
                    filters: filtersRel
                  }"/>
            </v-col>
          </v-row>
        </expansionPanelDefault>

        <v-skeleton-loader
            :loading="loadingTable"
            :transition="'fade-transition'"
            height="500"
            type="table">
          <v-data-table
            :headers="headers"
            :items="listaItens"
            :search="search"
            width="300px"
            flat
            hide-default-footer
            :loading="loadingPag"
            :items-per-page.sync="itemsPerPage">

            <!-- <template v-slot:top>
              <BrToolBar
                @search="buscar"
                :configFilter="{
                    activeSwitchStatus: false,
                    disableFilter: true,
                    disableReload: true,
                  }"
                :addlFilter="false"
                :labelTextField="'Busca por CPF:'" />
            </template> -->

            <!-- <template v-slot:body="{ items }">
              <tbody>
                <tr
                  v-for="item in items"
                  :key="item.id">
                  <td>{{ item.id }}</td>
                  <td>{{ item.name }}</td>
                  <td>{{ item.cod }}</td>
                  <td>{{ item.email }}</td>
                  <td>{{ item.cpf | document }}</td>
                  <td>{{ item.date }}</td>
                  <td>
                    <v-btn
                      tile
                      outlined
                      :color="variables.colorPrimary"
                      @click="deleteUsuario(item)"
                      v-if="permiteAcao($route, 'delete')">
                      {{ item.status === 'A' ? 'Ativo' : 'Inativo' }}
                    </v-btn>
                  </td>
                </tr>
              </tbody>
            </template> -->

            <template v-slot:item.jsonData.phone="{ item }">
              {{ `${item.jsonData.dddPhone}${item.jsonData.phone}` | phone }}
            </template>

            <template v-slot:item.created="{ item }">
              {{ item.created | datas }}
            </template>

            <template v-slot:item.entityRev="{ item }">
              {{ item.entityRev ? item.entityRev.cod : '-' }}
            </template>

            <template v-slot:item.entityPro="{ item }">
              {{ item.entityPro ? item.entityPro.cod : '-' }}
            </template>

            <template v-slot:item.status="{ item }">
              <v-chip :color="getColor(item.deleted)" dark>{{ statusUsuario(item.deleted) }}</v-chip>
            </template>

            <template v-slot:item.balanceAcc="{ item }">
              {{ item.balanceAcc | currency }}
            </template>

            <!-- <template v-slot:item.balancePrizes="{ item }">
              {{ item.balancePrizes | currency }}
            </template> -->

            <template v-slot:item.actions="{ item }">
              <v-row
                dense>
                <v-col cols="6" sm="12" md="6" class="pt-0 pb-0">
                  <!-- <template v-if="enabledPix.buyCredits.includes(item.id)">
                    <v-btn
                      block
                      dense
                      tile
                      outlined
                      :color="getColor(item.deleted, true)"
                        :disabled="!situacaoUsuario(item.deleted)"
                      @click.stop="desabilitarPix(item)"
                      v-if="permiteAcao($route, 'delete')"
                      :loading="loadingBtns"
                    >
                      Desabilitar Pix
                    </v-btn>
                  </template>

                  <template v-else>
                    <v-btn
                      block
                      dense
                      tile
                      outlined
                      :color="variables.colorGreenDarken"
                      :disabled="!situacaoUsuario(item.deleted)"
                      @click.stop="habilitarPix(item)"
                      v-if="permiteAcao($route, 'delete')"
                      :loading="loadingBtns"
                    >
                      Habilitar Pix
                    </v-btn>
                  </template> -->

                  <v-btn
                    class=""
                    style="width: 100%"
                    block
                    dense
                    tile
                    outlined
                    :color="variables.colorPrimary"
                    :disabled="!situacaoUsuario(item.deleted)"
                    @click.stop="resetPassword(item)"
                    v-if="permiteAcao($route, 'edit')"
                    :loading="loadingBtns"
                  >
                    Resetar Senha
                  </v-btn>
                </v-col>

                <v-col cols="6" sm="12" md="6" class="pt-0 pb-0">
                  <v-btn
                    style="width: 100%"
                    class="mb-1 "
                    tile
                    block
                    dense
                    outlined
                    :color="variables.colorPrimary"
                    @click="opemModalDadosUsuario(item)"
                    v-if="permiteAcao({ path: '/gestao/entidades/usuarios-web/view/'}, '') || permiteAcao($route, 'edit')">
                    {{ permiteAcao($route, 'edit') ? 'Editar' : 'Visualizar' }}
                  </v-btn>

                  <v-btn
                    style="width: 100%"
                    tile
                    block
                    dense
                    outlined
                    :color="getColor(item.deleted, true)"
                    @click.stop="deleteUsuario(item)"
                    v-if="permiteAcao($route, 'delete')">
                    {{ acaoBtn(item.deleted)  }}
                  </v-btn>
                </v-col>
              </v-row>
            </template>

            <template slot="body.append">
              <tr style="background: #666; color:white;">
                  <th colspan="12" style="font-weight: 600 !important">Total de créditos: {{ totalBalances | currency }} </th>
              </tr>
            </template>


            <template v-slot:footer>
              <div class="wrapper-footer">
                <div class="qtd-paginacao">
                  {{ pageStart }}
                  -
                  {{ pageStop }}
                  de
                  {{ totalItens }}
                </div>
                <v-pagination
                  v-model="page"
                  :length="numberOfPages"
                  circle
                  :disabled="disabled"
                  :total-visible="10"
                  class="box-table-paginacao"
                  v-if="numberOfPages > 1"></v-pagination>
              </div>
            </template>
          </v-data-table>
        </v-skeleton-loader>
      </div>
    </v-container>

    <ModalMotivoExclusao 
      :isActiveModal="isOpenModalMotivoExclusao"
      :entity="entitySelected"
      @deletarUsuario="deletarUsuario"
      @close-modal="closeModalMotivoExclusao"
    />

    <BrModalCadastro />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Events from '@/core/service/events'
import moment from 'moment'
import { errorSnackbar  } from '@/core/service/utils'

/*
* Mixins
*/
import listagemTables from '@/views/mixins/listagemTables'

export default {
  name: 'UsuarioWeb',
  mixins: [listagemTables],
  components: {
    // eslint-disable-next-line vue/no-unused-components
    BrToolBar: () => import('./components/toolbar'),
    ModalMotivoExclusao: () => import('./components/modalMotivoExclusao'),
    expansionPanelDefault: () => import('@/views/components/expansionPanelDefault'),
    FiltroRangeDate: () => import('@/views/components/filtroRangeDate'),
    generatePDF: () => import('@/views/components/PDFXLS'),
    BrModalCadastro: () => import('@/views/components/modalDadosUsuario')
  },
  data: () => ({
    search: '',
    headers: [
      { align: 'start', class: 'table-header', text: 'ID', value: 'id' },
      { align: 'start', class: 'table-header', text: 'Nome', value: 'jsonData.fullName' },
      { align: 'start', class: 'table-header', text: 'CPF', value: 'cod' },
      { align: 'start', class: 'table-header', text: 'Email', value: 'email' },
      { align: 'start', class: 'table-header', text: 'Telefone', value: 'jsonData.phone' },
      { align: 'end', class: 'table-header', text: 'Total de créditos', value: 'balanceAcc' },
      // { align: 'start', class: 'table-header', text: 'Total de Prêmios', value: 'balancePrizes' },
      // { align: 'center', class: 'table-header', text: 'Rev', value: 'entityRev' },
      // { align: 'center', class: 'table-header', text: 'Promotor', value: 'entityPro' },
      { align: 'start', class: 'table-header', text: 'Data', value: 'created' },
      { align: 'start', class: 'table-header', text: 'Depósito', value: 'deposit' },
      { align: 'start', class: 'table-header', text: 'Btag', value: 'btag' },
      { align: 'start', class: 'table-header', text: 'Status', value: 'status' },
      { align: 'end', class: 'table-header', text: '', value: 'actions' },
    ],
    relHeaders: [
      { dataKey: 'id', header: 'ID', type: 'text' },
      { dataKey: 'jsonData.fullName', header: 'Nome', type: 'text' },
      { dataKey: 'cod', header: 'CPF', type: 'text' },
      { dataKey: 'email', header: 'Email', type: 'text' },
      { dataKey: 'jsonData.phone', header: 'Telefone', type: 'text' },
      { dataKey: 'balanceAcc', header: 'Total de créditos', type: 'currency' },
      // { dataKey: 'entityRev', header: 'Rev', type: 'text' },
      // { dataKey: 'entityPro', header: 'Promotor', type: 'text' },
      { dataKey: 'created', header: 'Data', type: 'date' },
      { dataKey: 'deposit', header: 'Depósito', type: 'text' },
      { dataKey: 'btag', header: 'Btag', type: 'text' },
      { dataKey: 'status', header: 'Status', type: 'text' },
    ],
    loadingBtns: false,
    lastSearch: '',
    isOpenModalMotivoExclusao: false,
    entitySelected: undefined,
    typeFilter: 'cpf',
    rangeDateCreated: {
      start: null,
      end: null
    },
    rangeDateDeposito: {
      start: null,
      end: null
    },
    textSearch: null,
    filter: {},
    positiveBalance: false
  }),
  mounted(){
    Events.$on('UsuarioWeb::buscarUsuarioAtualizado', () => {
      this.buscar()
    }),
    Events.$on('relPage::loading', e => {
      this.loadingPag = e
    })
  },
  computed: {
    ...mapGetters('jogadores', {
      listaItens: 'listaItens',
      totalItens: 'totalItens',
      totalBalances: 'totalBalances',
      isStatus: 'isStatus',
      enabledPix: 'enabledPix',
    }),
    ...mapGetters('roles', ['permiteAcao']),

    listaKeys () {
      return {
        cpf:  '',
        name:  '',
        birth:  '',
        phone:  '',
        influencer:  '',
        bank: '',
        agency: '',
        account: '',
        digit: '',
        accountType: '',
        email:  '',
      }
    },

    typeFilters () {
      return [
        {
          text: 'CPF',
          value: 'cpf'
        },
        {
          text: 'Email',
          value: 'email'
        },
        {
          text: 'Telefone',
          value: 'phone'
        }
      ]
    },

    labelBuscar () {
      const obj = this.typeFilters.find(it => it.value === this.typeFilter)
      return obj.text
    },

    paramsRel () {
      // eslint-disable-next-line no-unused-vars
      const _addlFilter = this.formatFilters
      return { _addlFilter, relPDF: true, }
    },

    filtersRel () {
      const filtersList = this.montarLabelFiltro().filter(it => it.value)
      return filtersList.reduce((acc, item) =>`${acc}${item.label} ${item.value}, `, '')
    },

    formatFilters () {
      const filter = {
        positiveBalance: this.positiveBalance
      }

      if (this.textSearch) {
        switch (this.typeFilter) {
          case 'email':
            filter.email = this.textSearch
            break
          case 'phone':
            filter.phone = this.textSearch.replace(/[^\d]/g, '')
            break
          case 'cpf':
          default:
            filter.cpf = this.textSearch.replace(/[^\d]/g, '')
        }
      }

      if (this.rangeDateCreated.start) {
        filter.dtStart = moment(this.rangeDateCreated.start).format('YYYY-MM-DD 00:00:00')
      }
      if (this.rangeDateCreated.end) {
        filter.dtEnd = moment(this.rangeDateCreated.end).format('YYYY-MM-DD 23:59:59')
      }
      if (this.rangeDateDeposito.start) {
        filter.dtStartDeposit = moment(this.rangeDateDeposito.start).format('YYYY-MM-DD 00:00:00')
      }
      if (this.rangeDateDeposito.end) {
        filter.dtEndDeposit = moment(this.rangeDateDeposito.end).format('YYYY-MM-DD 23:59:59')
      }

      return filter
    },
  },

  methods: {
    ...mapActions('jogadores', ['getItens', 'editarItem', 'deletarItem', 'clearItens', 'getItem', 'switchStatus', 'editSaveItem', 'getEnabledPix']),

    buscar() {
      const filter = this.formatFilters
      this.filter = filter

      this.page = 1
      this.loadingPag = true

      this.getItens({ ...filter, page: this.page, pageSize: this.$store.getters.ItensPaginacao })
        .then(result => {
          if (result.data.totalItens < 1) {
            errorSnackbar('Não há dados disponíveis')
          }
        })
        .catch(err => {
          errorSnackbar(err.error)
        })
        .finally(() => { this.loadingPag = false })
    },

    statusUsuario (date) {
      return this.situacaoUsuario(date) ? 'Ativo' : 'Inativo'
    },

    acaoBtn (date) {
      return this.situacaoUsuario(date) ? 'Desativar' : 'Ativar'
    },

    getColor (date, inverso = false) {
      return (inverso ? !this.situacaoUsuario(date) : this.situacaoUsuario(date))  ? this.variables.colorSecondary : this.variables.colorError
    },

    situacaoUsuario (date) {
      return moment(date, 'YYYY-MM-DD').isSame(moment('1970-01-01'), 'year') ? !!1 : !!0
    },

    init() {
      this.getEnabledPix()
      this.loadingTable = false
      const isListaTodosWeb = this.permiteAcao({ path: '/gestao/entidades/usuarios-web/full/' })
      if (!isListaTodosWeb) return

      this.loadingTable = true
      this.loadingPag = true
      this.getItens({ page: this.page, pageSize: this.$store.getters.ItensPaginacao, ...this.filter })
        .then(result => {
          if (result.data.totalItens < 1) {
            errorSnackbar('Não há dados disponíveis')
          }
        })
        .catch(err => {
          errorSnackbar(err.error)
        })
        .finally(() => {
          this.loadingTable = false
          this.loadingPag = false
        })
    },

    paginacao (pag) {
      this.loadingPag = true
      this.disabled = true
      this.setPage(pag)
      window.scroll({
        top: 0,
        left: 0,
        behavior: 'smooth'
      })
      
      this.getItens({ page: pag, pageSize: this.$store.getters.ItensPaginacao, ...this.filter })
      .finally(() => {
        this.loadingPag = false
        this.disabled = false
      })
    },

    resetPassword (user) {
      const lista = "0123456789BCDFGHJKLMNPQRSTVWXYZ".split('')
        const customEpoch = moment('2018-01-01 00:00:00').format('x')
        const now = moment().format('x')
        let t_diferenca = (now - customEpoch)/1000
        let retorno = ""
        while(t_diferenca > lista.length - 1) {
            let resto = t_diferenca % lista.length
            t_diferenca = (t_diferenca - resto) / lista.length
            retorno += lista[parseInt(resto)]
        }
        retorno += lista[parseInt(t_diferenca)]

        const senha = retorno.split('').reverse().join('')

      this.$swal({
        icon: 'warning',
        text: `Tem certeza que deseja resetar senha do usuario: ${user.jsonData.fullName}`,
        showCancelButton: true,
        confirmButtonText: 'Sim',
        cancelButtonText: 'Não',
      }).then((result) => {
        if (result.value) {
          this.loadingBtns = true

          this.editSaveItem({ id: user.id,  password: senha, typeEdit: 'reset-password' })
            .then(() => {
              this.$swal({
                icon: 'success',
                text: `Senha resetada com sucesso, nova senha: ${senha}`,
              })
            })
            .finally(() => this.loadingBtns = false)
            }
      })
    },

    habilitarPix (user) {
      this.loadingBtns = true
      this.editSaveItem({ id: user.id, typeEdit: 'enable-pix' })
        .then(() => {
          this.$swal({
            icon: 'success',
            text: 'Pix liberado com sucesso!',
          })
        })
        .finally(() => {
          this.loadingBtns = false
          this.init()
        })
    },

    desabilitarPix (user) {
      this.loadingBtns = true
      this.editSaveItem({ id: user.id, typeEdit: 'disable-pix' })
        .then(() => {
          this.$swal({
            icon: 'success',
            text: 'Pix desabilitado com sucesso!'
          })
        })
        .finally(() => {
          this.loadingBtns = false
          this.init()
        })
    },

    deleteUsuario (item) {
      if (item.status === 'A') {
        this.isOpenModalMotivoExclusao = true
        this.entitySelected = item
      } else {
        this.$swal({
          icon: 'warning',
          text: `Tem certeza que deseja reativar o usuario: ${item.jsonData.fullName}`,
          showCancelButton: true,
          confirmButtonText: 'Sim',
          cancelButtonText: 'Não',
        }).then((result) => {
          if (result.value) {
            this.deletarUsuario({ entityId: item.id, isStatus: 'activate', motivoExclusao: undefined, outrosMotivosExclusao: undefined })
          }
        })
      }
    },

    deletarUsuario ({ entityId, isStatus, motivoExclusao, outrosMotivosExclusao }) {
      this.isOpenModalMotivoExclusao = false
      this.entitySelected = undefined
      this.deletarItem({ id: parseInt(entityId), status: isStatus, motivoExclusao, outrosMotivosExclusao }).then(() => {
        this.loadingPag = true
        this.buscar(this.lastSearch)
        const msg = {
          toggle: true,
          type: 'success',
          msg: 'Alteração realizada com sucesso!'
        }
        Events.$emit('snackbarCadastro::msg', msg)
      }).catch(err => {
        const msg = {
          toggle: true,
          type: 'error',
          msg: err.error
        }
        Events.$emit('snackbarCadastro::msg', msg)
      })
    },

    closeModalMotivoExclusao () {
      this.isOpenModalMotivoExclusao = false
      this.entitySelected = undefined
    },

    opemModalDadosUsuario (e) {
      Events.$emit('cadastro::openModalCadastro', e)
    },

    montarLabelFiltro () {
      let labelFiltro = [
        {
          label: `${this.labelBuscar}:`,
          value: this.textSearch
        },
        {
          label: 'Data Cadastro Inicial:',
          value: this.rangeDateCreated.start ? moment(this.rangeDateCreated?.start).format('DD/MM/YYYY') : null
        },
        {
          label: 'Data Cadastro Final:',
          value: this.rangeDateCreated.end ? moment(this.rangeDateCreated?.end).format('DD/MM/YYYY') : null
        },
        {
          label: 'Data Depósito Inicial:',
          value: this.rangeDateDeposito.start ? moment(this.rangeDateDeposito?.start).format('DD/MM/YYYY') : null
        },
        {
          label: 'Data Depósito Final:',
          value: this.rangeDateDeposito.end ? moment(this.rangeDateDeposito?.end).format('DD/MM/YYYY') : null
        },
        {
          label: 'Saldo Positivo:',
          value: this.positiveBalance ? 'Sim' : 'Não'
        },
      ]
      return labelFiltro
    },

    filtrarCreated (e) {
      this.rangeDateCreated = {
        start: e.start,
        end: e.end
      }

      // this.handlerRequestDispatches()
    },

    filtrarDeposito (e) {
      this.rangeDateDeposito = {
        start: e.start,
        end: e.end
      }

      // this.handlerRequestDispatches()
    },
  }
}
</script>

<style lang="scss" src="@/assets/styles/view/usuarios-web.scss"></style>

